import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import DataTable from './DataTable.json';
import DatePicker from './DatePicker.json';
import Header from './Header.json';
import InvestigationalUseDialog from './InvestigationalUseDialog.json';
import Modes from './Modes.json';
import StudyList from './StudyList.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import MeasurementTable from './MeasurementTable.json';
import DataRow from './DataRow.json';
import Messages from './Messages.json';

export default {
  'pt-BR': {
    AboutModal,
    Buttons,
    CineDialog,
    Common,
    DataTable,
    DatePicker,
    Header,
    InvestigationalUseDialog,
    Modes,
    StudyList,
    UserPreferencesModal,
    MeasurementTable,
    DataRow,
    Messages,
  },
};
